<template>
	<div class="table-box">
		<el-table
				:data="data"
				style="width: 100%">
			<el-table-column
					label="导入时间"
					prop="importDate"
					min-width="90px">
			</el-table-column>
			<el-table-column
					label="导入名称"
					prop="name">
			</el-table-column>
			<el-table-column
					label="结果"
					prop="result"
					min-width="200px">
			</el-table-column>
			<el-table-column
					label="操作"
					align="center">
				<template slot-scope="scope">
					<a class="el-button el-button--text" :href="api + importErrorLink + scope.row.id+'?id='+scope.row.id">失败数据下载</a>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	import store from '@/store/index'
	export default {
		name: 'LyImportError',
		props: {
			data: {
				type: Array,
				default: []
			},
			importErrorLink: {
				type: String,
				default: ''
			}
		},
		created() {
			this.api = store.getters.objApi.BASE_API;
		}
	}
</script>
<style scoped>
	.table-box {font-size: 12px;}
</style>



// WEBPACK FOOTER //
// src/components/import-error/index.vue